var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 24,
    rx: 5.5,
    fill: "#F6F7FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.977 8H22.6231L20.3771 13.2854L17.9516 8H14.6278V15.1868L11.5434 8H8.56368L5 16.235H7.32073L8.05437 14.4531H11.9622L12.6958 16.235H16.7683V10.3508L19.3886 16.235H21.1704L23.7756 10.3656V16.235H25.9617L25.9768 8L25.977 8ZM10.0162 9.7668L11.1691 12.5668H8.86344L10.0164 9.7668H10.0162ZM34.0473 9.88661V8.61383L37.1468 12.1174L34.0473 15.4712V14.3631H29.6004V12.9856H33.9724V11.1291H29.6004V9.88636H34.0473V9.88661ZM39.9317 12.1326L43.72 8.00025H40.995L38.5993 10.5756L36.2786 8.00025H27.4746V16.2502H36.1588L38.5695 13.645L40.8902 16.2502H43.6902L39.932 12.1329L39.9317 12.1326Z",
    fill: "#286CB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.dbddbf221ca1d4d4ccb1d909465532e2.svg";
export { ForwardRef as ReactComponent };